import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100vh',
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  brand: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '24px 24px 0'
    }
  },
  brandContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    width: '100%',
    maxWidth: '720px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '16px'
    }
  },
  logo: {
    // width: '471px',
    height: '95px',
    content: theme.appLogoAdImg
      ? `url(${theme.appLogoAdImg})`
      : theme.palette.type === 'dark'
        ? 'url(' + theme.calculatedLogoDark() + ')'
        : 'url(' + theme.calculatedLogoLight() + ')',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    [theme.breakpoints.up('lg')]: {
      height: '120px'
    },
    [theme.breakpoints.up('xs')]: {
      height: '100px'
    }
  },
  logoForm: {
    width: '248px',
    height: '85px',
    content: 'url(' + theme.calculatedLogoDark() + ')',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  login: {
    background:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : 'linear-gradient(90deg, rgba(25,127,255,1) 0%, rgba(37,211,255,1) 100%)',
    height: '100vh',
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '30px',
    }
  },
  formContent: {
    width: '434px',
    background:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 32px 32px 32px',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 32px 32px',
      gap: '4px',
      width: '360px',
    }
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  loginWarningBox: {
    width: '100%',
    border: `1px solid ${theme.palette.red_100.main}`,
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.dark_400.main : '#fff2f2',
    borderRadius: 10,
    padding: '12px 14px',
    marginBottom: '8px'
  },
  loginWarningTitle: {
    color: theme.palette.red_100.main,
    fontWeight: 700,
    fontSize: '1rem',
    marginBottom: '6px'
  },
  loginWarningText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '0.92rem',
    lineHeight: 1.45
  },
  title: {
    textAlign: 'center',
    fontSize: '2rem',
    color: theme.palette.blue_300.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem'
    }
  },
  submit: {
    width: '100%',
    backgroundColor: theme.palette.blue_300.main,
    color: 'white',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      color: 'white',
      boxShadow: 'none'
    }
  },
  loginLinksRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    marginTop: '-2px'
  },
  loginHelperLink: {
    color: theme.palette.blue_300.main,
    textTransform: 'capitalize',
    '&:hover': {
      color: theme.palette.blue_400.main
    }
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  inputText: {
    background:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    borderRadius: 5
  },
  label: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  buttonsDownload: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    '& span': {
      fontSize: '1rem',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  iconDownload: {
    padding: theme.spacing(1),
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.1)',
      backgroundColor: 'transparent'
    },
    '& img': {
      width: '100%',
      height: '100%'
    }
  },
  storeIcon: {
    width: 32,
    height: 32
  },

  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  description: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  recoveryDialogPaper: {
    borderRadius: 16,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },
  recoveryDialogContent: {
    padding: '20px 28px 26px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
    [theme.breakpoints.down('xs')]: {
      padding: '18px 16px 22px'
    }
  },
  backToLoginLink: {
    alignSelf: 'flex-start',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '0.95rem',
    fontWeight: 500,
    marginBottom: 4,
    '&:hover': {
      color: theme.palette.blue_300.main
    }
  },
  recoveryDialogTitle: {
    color: theme.palette.blue_300.main,
    fontSize: '2rem',
    fontWeight: 700,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.7rem'
    }
  },
  recoveryDialogSubtitle: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    textAlign: 'center',
    fontSize: '1rem',
    maxWidth: 360,
    marginBottom: 8,
    lineHeight: 1.4
  },
  recoveryOptionButton: {
    width: '100%',
    border: `1px solid ${theme.palette.gray_100.main}`,
    borderRadius: 12,
    height: 54,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    color: theme.palette.blue_300.main,
    fontSize: '1.04rem',
    fontWeight: 600,
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.blue_300.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.blue_50.main,
      textDecoration: 'none'
    }
  },
  recoveryOptionIcon: {
    fontSize: '1.25rem',
    color: theme.palette.blue_300.main
  },
  recoverySupportBlock: {
    marginTop: 14,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2
  },
  recoverySupportText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '0.95rem'
  },
  recoverySupportLink: {
    color: theme.palette.blue_300.main,
    fontWeight: 600,
    '&:hover': {
      color: theme.palette.blue_400.main
    }
  }
}))
